module.exports = __webpack_public_path__ + "static/assets/04b84dc9f5725050ed8aadddc8dc685c.gif";